import BaseView from '../../base-view';

export default BaseView.extend({
	events: {
		'click .js-tab-item': 'onTabClick'
	},

	initialize: function() {
		// Cache active tab and panel
		this.activeTab = this.el.querySelector('.js-tab-item.is-active');
		this.panels = [].slice.call(this.el.querySelectorAll('.js-tab-panel'));
		//this.activePanel = this.el.querySelector('.js-tab-panel.is-active');
	},

	render: function() {
		return this;
	},

	onTabClick: function(e) {
		e.preventDefault();

		var clickedTab = e.currentTarget,
			clickedTabTarget = clickedTab.getAttribute('data-tab');

		// Toggle clicked target
		if (this.activeTab !== clickedTab) {
			this.toggle(clickedTab, clickedTabTarget);
		}
	},

	toggle: function(clickedTab, clickedTabTarget) {
		var targetPanel = this.el.querySelector('#' + clickedTabTarget);

		this.panels.forEach(function(panel) {
			panel.classList.add('is-hidden');
			targetPanel.classList.remove('is-hidden');
		});

		// Toggle active state class for tab
		this.activeTab.classList.remove('is-active');
		clickedTab.classList.add('is-active');

		// Update active tab
		this.activeTab = clickedTab;
	}
});

